export const validatePredictionFootage = (value: string) => {
  const n = parseInt(value, 10); // Parse the string as a base-10 integer
  return /^\d+$/.test(value) && Number.isInteger(n) && n >= 0 && n <= 999999999;
};
